const ja = {
  9000001: "2023 クリスマス",
  9000002: "カップ - スーパーエックス・フューチャーズ",
  9000003: "トレーディング・コンペティション、賞金30,000USDTが当たる",
  9000004: "参加者数",
  9000005: "アンロック・ジャックポット（USDT）",
  9000006: "先物取引高ランキング予選会",
  9000007: "先物利回りランキング ",
  9000008: " プロフィットランキング予選",
  9000009: `最大 <span style="color: #ffc72b;">20,000</span> USDTのボーナスプールをアンロックする先物取引高ランキング大会 `,
  9000010: "参加者数に応じて賞金総額が増え、最大20,000USDTとなる。 ",
  9000011: "ジャックポット金額",
  9000012: "開催期間中、毎日10:00（UTC）に更新",
  9000013: "賞金見積もり ",
  9000014: "先物総取引高",
  9000015: "表彰規定 ",
  9000016: "参加者数に応じて賞金総額が増え、最大20,000USDTとなる。 ",
  9000017: "ジャックポット金額（USDT）",
  9000018: "活動収益率ランキング",
  9000019: "サインアップ",
  9000020: "活動の利益額ランキング",
  9000021: "終了",
  9000022: `先物利回りランキングコンテスト、賞金 <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
  9000023: `利益ランキング大会、<span style="color: #ffc72b;">{moneyPond}</span> USDTボーナス`,
  9000024: "グロス先物利回り",
  9000025: "先物利益総額",
  9000026: "開始していません",
  9000027: "上位50名の参加者にはボーナス報酬が与えられます。ボーナス報酬を得るには、取引ランキング報酬ルールをご参照ください。",
  9000028: "先物利回りの上位50名の参加者には報酬が与えられます。報酬を得るには、取引ランキング報酬規則を参照してください。",
  9000029: "アクティビティ取引量ランキング",
  9000030: "登録に成功しました",
  9000031: "アプリをダウンロードする",
  9000032: "戻る首页",

  //合约交易积分
  9100001: "ポイントを貯める",
  9100002: "空中投下を受ける",
  9100003: "インセンティブ",
  9100004: "ポイント残高",
  9100005: "詳細",
  9100006: "チェックインポイント",
  9100007: "取引ポイント",
  9100008: "ゆうどうせきぶん",
  9100009: "ボーナスポイント",
  9100010: "ラッキーくじ",
  9100011: "ポイントの取得",
  9100012: "せきぶんそく",
  9100013: "積分明細",
  9100014: "このイベントに参加するには応募が必要で、クリックすれば参加できます",
  9100015: "{day}日連続取引を行い、{num}ポイントを獲得した",
  9100016: "今日得た {num} ポイント",
  9100017: "せきぶんプール",
  9100018: "抽選ごとに {point} ポイントを消費し、1日最大 {num} 回引く",
  9100019: "本日の抽選回数",
  9100020: "ユーザー",
  9100021: "せきぶん",
  9100022: "ポイント残高不足",
  9100023: "ポイント残高が不足しておりますので、ポイントを取得してから抽選にご参加ください",
  9100024: "抽選回数が上限に達しました",
  9100025: "今日の抽選回数は上限に達しましたので、明日もう一度試してください。",
  9100026: "ポイントの獲得方法",
  9100027: "サインアップして契約取引ポイント獲得アクティビティに参加し、ポイントを獲得してください。",
  9100028: "参加申し込み成功",
  9100029: "契約取引に応募してポイントを獲得して、取引に行ってもっとポイントを獲得しましょう（コミッション還元奨励を受けなくなります）",
  9100030: "申し込みをキャンセルすると、ポイントはもらえなくなりますが、本当にキャンセルしますか。",
  9100031: "取引ポイント活動センター",
  9100032: "ポイントの取得",
  9100033: "このイベントに参加するには応募が必要で、クリックすれば参加できます",
  9100034: "契約に連続して参加することでポイントを得ることができます",
  9100035: "ユーザーが契約市場で発生したすべての取引行為がポイントを取得することができます",
  9100036: "ランキングポイント",
  9100037: "毎日の取引ランキング上位5位にボーナスポイントが追加される",
  9100038: "招待された人はポイントを生成し、招待者は奨励ポイントを得ることができる",
  9100039: '{guy} 当選済み<span style="color:#D9A31A"> {num} ポイント</span>',
  9100040: "今すぐくじを引く",
  9100041: "ご獲得おめでとうございます",
  9100042: "すべてのタイプ",
  9100043: "このページにとどまります",
  9100044: "登録に参加する",
  9100045: "取引を続ける",
  9100046: "継続的な活動はありませんので、しばらくお待ちください...",
  9100047: "SCS トークンを引き換える",
  9100048: "",
  9100049: "",

  9100050: "時間",
  9100051: "スタート時間",
  9100052: "終了時間",
  9100053: "に/まで",
  9100054: "タイプ",

  9100055: "獲得ポイント = 取引量 * 1% (プラットフォームの総取引量が増加するにつれて、難易度はさらに調整されます)",
  9100056: "例: ユーザーは 100USDT*100X=10000U のマージンを持つポジションを使用します。",
  9100057: "100ポイントを獲得するには100USDTのデポジットのみが必要です",
  9100058: "プラットフォームトークンSCSを入手するには取引ポイントが唯一の方法です",
  9100059: "追加ボーナスポイント＝当日の合計ポイント×ランキング報酬率",
  9100060: "ランキング",
  9100061: "1位",
  9100062: "2位",
  9100063: "3位",
  9100064: "4位",
  9100065: "5位",
  9100066: "招待された人はポイントを生成し、招待者は奨励ポイントを得ることができる",
  9100067: "勾配係数",
  9100068: "計算式：獲得昇格ポイント＝招待者が獲得するポイント×レベル係数",
  9100069: "レベル係数は実際の状況に応じて調整されます",
  9100070: "例: ユーザー B がポイント アクティビティに参加し、その招待者はユーザー A で、ユーザー A からの招待数はレベル 3 に達し、ユーザー B はポイント = 360,000 を蓄積しています。",
  9100071: "ユーザー A が獲得できる累積プロモーション ポイント = 360000*30% = 108,000",
  9100072: "インセンティブ係数",
  9100073: "取引ユーザー1名",
  9100074: "トランザクション量が500Wに達する",
  9100075: "トランザクション量が2000Wに達する",

  9100076: "出入金",

  //热币
  9100080: "イベントは終了しました",
  9100081: "「サインアップ」をクリックして賞品を獲得しましょう",
  9100082: "ルールの表示",
  9100083: "参加を申し込む",
  9100084: "イベント",
  9100088: "貿易",
  9100089: "デポジット",
  9100090: "イベントに既に申し込み済みです。",

  9100091: "このイベントは終了しました。次のイベントにご期待ください。",
  9100092: "イベントはまだ始まっていませんので、お待ちください。",
  9100093: "",
  9100094: "",

  //api key
  9100105: "APIキーの作成",
  9100106: "APIドキュメントの確認",
  9100107: "統合トレーディングシステム",
  9100108: "APIキーの作成/管理",
  9100109: "APIのデプロイ",
  9100110: "取引とリクエスト",
  9100111: "先導的なデジタル資産取引プラットフォーム",
  9100112: "豊富なデジタル資産取引および資産管理サービスを提供し、多様な取引ニーズに応えます。",
  9100113: "より良いサービスの提供",
  9100114: "より優れた取引手数料、より高い取引額、より柔軟なアカウント管理機能などを提供します。",
  9100115: "数百万のユーザーに信頼されています",
  9100116: "安全な取引環境を確保し、専門的なカスタマーサポートを提供し、デジタル資産の世界で着実に前進するお手伝いをします。",
  9100117: "SuperExでAPIキーを作成する方法は？",
  9100118: "SuperExのAPIドキュメントはどこで見ることができますか？",
  9100119: "SuperExで取引に問題が発生した場合はどうすればよいですか？",
  9100120: "SuperExのAPIを使用する方法は？",
  9100121: "SuperEx APIに接続し、取引をより迅速かつスムーズに行います",
  9100122: "ログイン状態でアバター上にマウスを置き、「API管理」をクリックし、「APIキーの作成」をクリックして、SuperExで自分のAPIキーを作成します。注：ログインしていない場合は、まずSuperExのアカウントにログインする必要があります。 また、画面下部の「APIs」ナビゲーションバーから入り、SuperExで自分のAPIキーを作成することもできます。",
  9100123: '<a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com/en/quickStart.html">APIドキュメント</a>をクリックして、SuperExのAPIドキュメントを確認できます',
  9100124: "使用中に問題がある場合や提案がある場合は、以下の方法でお問い合わせいただけます： <br>公式ウェブサイトの「ヘルプセンター」を利用するか、support@superex.com にメールを送ってカスタマーサービスに連絡してください。",
  9100125: `SuperExのAPIを使用するには、以下の手順が必要です：<br>
SuperExアカウントに登録し、ログインします。<br>
APIキーを作成すると、access_keyとsecret_keyが生成されます。<br>
このaccess_keyとsecret_keyを使用してリクエストに署名します。<br>
必要に応じて、SuperExが提供するさまざまなAPIを使用できます。例えば、市場データAPI、取引API、アカウントAPIなどがあります。各リクエストはAPIドキュメントの指示に従い、適切なHTTPヘッダと署名が必要で`,
  9100126: "APIキー管理",
  9100127: "新しいAPIキーの作成",
  9100128: "備考名",
  9100129: "備考名を入力してください",
  9100130: "権限設定（複数選択可能）",
  9100131: "読み取り",
  9100132: "取引",
  9100133: "IPアドレスの紐付け（任意）",
  9100134: "複数のIPアドレスは英語のコンマで区切り、最大10個まで入力可能",
  9100135: "私は読んで同意しました",
  9100136: "APIユーザーリスク通知に同意しました",
  9100137: "作成",
  9100138: 'SuperExは強力なAPIを提供しています。このAPIを通じて、市場情報の照会や自動取引などのサービスを利用できます。<a style="color:#0052D9;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com/en/quickStart.html">APIドキュメント</a>で使用方法を確認してください。',
  9100139: "ユーザーは最大で10組のAPIキーを作成できます",
  9100140: "Pアドレスが紐付けられていないAPIキーは、90日後に自動的に無効になります。長期間使用する場合は、以下の「私のAPIキー — 操作 — 更新」からAPIキーの有効期限を90日延長することができます。IPアドレスが紐付けられているAPIキーには有効期限がありません。",
  9100141: "私のAPIキー",
  9100142: "権限",
  9100143: "IPアドレスの紐付け",
  9100144: "更新",
  9100145: "APIキーを作成するためには、スポットウォレットに任意の金額を入金してアカウントを有効化する必要があります",
  9100146: "現在のAPIキーの更新を確認してください",
  9100147: "Access KeyおよびSecret Keyを漏洩しないでください。それにより資産損失が生じる可能性があります。",
  9100148: "セキュリティ上の理由から、APIキーにIPアドレスをバインドすることをお勧めします。各APIキーには最大10個のIPアドレスをバインドできます。単一のIPアドレスを直接入力し、複数のIPアドレスはカンマで区切ってください。例：192.168.1.1,192.168.1.2",
  9100149: "更新に成功すると有効期限が再計算されます。APIキーを長期間使用する場合は、IPアドレスを紐付けすることをお勧めします。紐付けられたAPIキーは有効期限がなく、さらに安全です。",
  9100150: "現在のAPIキーを削除しますか？",
  9100151: "次のリスクを理解する必要があります：",
  9100152: "APIキーはあなたのアカウントの安全性と密接に関連しています。あなたのAPIキーを知っている第三者はあなたのアカウント資産を制御する可能性がありますので、APIキーを適切に保管し、第三者には公開せず、第三者のウェブサイトやフォーラムにアップロードしないでください。",
  9100153: "あなたの個人的な理由でAPIキーが漏れた場合、資産の安全問題、経済的損失問題などを含むすべての責任はあなたが負担します。私たちはこれに対して責任を負いません。",
  9100154: "リスクの通知",
  9100155: "私はリスクを認識し、自発的に受け入れる意思があることを知らせます。",
  9100156: "保存しました",
  9100157: "権限設定",
  9100158: "キーは一度だけ表示され、失われた後は回復できません。必ず安全に保管してください。",
  9100159: "Access KeyおよびSecret Keyを漏洩しないでください。それにより資産損失が生じる可能性があります。",
  9100160: "Secret Keyを忘れた場合は、そのキーペアを削除して新しいキーペアを申請してください。",
  9100161: "強力なAPIを提供し、取引機能をアプリケーションに効率的に統合するお手伝いをします。APIはアカウント、取引、市場データの3種類に分けられ、ニーズに応じて適切な権限を設定し、APIを通じて自動取引を実現できます。",
  9100162: "作成日時",
  9100163: "新しいAPIキーの作成",
  9100164: "編集",
  9100165: "有効期限",
  9100166: "削除する",
  9100167: "作成が成功しました。",
  9100168: "ヒント",
  9100169: "わかった",
  9100170: "API ユーザーのリスクに関する警告",
  9100171: "IPアドレスの形式が正しくありません",
  9100172: "",
  //自由区二维码分享页面
  91000951: "自由区上場、富の自由を開始",
  91000961: "アプリを開く",
  //自由区二维码分享页面
  9100095: "自由区上場、富の自由を開始",
  9100096: "アプリを開く",
  9100097: "",
  9100098: "",

  //代理商
  101738: "SuperEx エージェントになって高額リベートを享受",
  101739: "SuperEx での取引に友人を招待すると、50% の手数料リベートが得られ、友人が約定取引を行った後は、手数料リベートを享受できます。",
  101740: "エージェントになる",
  101741: "コミッションを得る方法は?",
  101742: "代理店になるために申し込む",
  101743: "コミュニティ、メディア、その他のリソースをお持ちの場合は、エージェントに申請でき、申請が成功した後、エージェントにアップグレードできます。",
  101744: "スーパーエクスの推進",
  101745: "宣伝や露出のために招待リンクをコミュニティ、ファン、または他のチャンネルと共有します。",
  101746: "手数料収入を得る",
  101747: "新しいユーザーが招待リンクを通じて登録して取引すると、コミッションを獲得できます",
  101748: "どれくらいのコミッションを獲得できますか?",
  101749: "SuperEx での取引にユーザーを招待すると、招待報酬として友人の手数料の 20% を受け取ることができます。",
  101750: "SuperEx エージェントになると、エージェント リベート報酬の 50% も受け取ることができます。",
  101751: "SuperEx エージェントになる理由?",
  101752: "高額な手数料リベート",
  101753: "50%の手数料リベート",
  101754: "交通サポート",
  101755: "プロの交通サポートで利益も得やすい",
  101756: "ブランドの祝福",
  101757: "グローバルなオフライン活動、カスタマイズされた共同ギフトと周辺機器",
  101758: "グローバルなオフライン活動",
  101759: "業界トップのカンファレンスであるSuperEXグローバルオフラインファンミーティングは、エージェントの皆様を全面的にサポートし、収入アップをサポートします。",
  101760: "レビューに失敗しました",
  101761: "エージェント",
  101762: "チャネル管理",
  101763: "チャンネルの作成",
  101764: "チャネル",
  101765: "プロモーションの方法は、",
  101766: "チャンネル名",
  101767: "作成時間",
  101768: "編集",
  101769: "先物取引から返されたコミッションの割合",
  101770: "現物取引から返されたコミッションの割合",
  101771: "プロモーション管理",
  101772: "エージェントの招待コードを作成する",
  101773: "招待コード",
  101774: "作成できる紹介リンクの残りの数",
  101775: "招待者の数",
  101776: "エージェントの招待コード",
  101777: "招待されたエージェントの数",
  101778: "通常の招待コードの数量",
  101779: "通常の招待者数",
  101780: "招待リンク",
  101781: "通常のチャンネル",
  101782: "データダッシュボード",
  101783: "入金数",
  101784: "取引量",
  101785: "コミッション",
  101786: "所属招待コード",
  101787: "モバイル招待関係",
  101788: "契約報告書",
  101789: "スポットレポート",
  101790: "トランザクション数",
  101791: "決済センター",
  101792: "契約決済",
  101793: "スポット決済",
  101794: "推定手数料",
  101795: "出金記録",
  101796: "アセットを表示",
  101797: "引き出し金額",
  101798: "累積手数料",
  101799: "現在のトークンが出金額を満たしていません。ボーナスを受け取るために、より多くのユーザーを取引に招待できます。",
  101800: "契約データの概要",
  101801: "スポットデータの概要",
  101802: "契約内容",
  101803: "スポット詳細",
  101804: "全方向",
  101805: "エージェントの推定手数料",
  101806: "ユーザーの推定手数料",
  101807: "トランザクション時間",
  101808: "詳しいルールはSuperExのお知らせをご覧ください",
  101809: "エージェントプログラム申込フォーム",
  101810: "あなたの言語",
  101811: "どこの国にいるの？ （例：イラン）",
  101812: "あなたの主なプラットフォーム/チャネルは何ですか?",
  101813: "あなたのプラットフォーム/ソーシャルメディア/ウェブサイトには何人のフォロワー/ファン/ユーザーがいますか?",
  101814: "メインのプラットフォーム/チャンネルのリンクを入力します (完全な URL を入力します)。",
  101815: "その他のソーシャル チャネル/Web サイトのリンク (完全な URL を入力)",
  101816: "あなたの名前",
  101817: "すぐに連絡できるようにソーシャル メディア チャネルを入力します (例: Telegram ID @xxx)",
  101818: "再販業者プログラムについてどこで知りましたか?",
  101819: "友達",
  101820: "あなた自身についてやチャンネルの簡単な紹介など、私たちと共有できるその他の情報",
  101821: "素晴らしい",
  101822: "SuperEx エージェントの申請が正常に完了しました。 審査通過後、メールにてご連絡させていただきます。",
  101823: "期間のスパンは3ヶ月を超えてはいけません",
  101824: "操作成功",
  101825: "すべて引き出し",
  101826: "引き出し済み",
  101827: "現在のトークンが出金額を満たしていません。ボーナスを受け取るために、より多くのユーザーを取引に招待できます。",
  101828: "ユーザー管理",
  101829: "ユーザID",
  101830: "契約キャッシュバック率",
  101831: "スポットキャッシュバック率",
  101832: "登録時間",
  101833: "取引明細",
  101834: "買い越し",
  101835: "空売り",
  101836: "売れ行きが横ばいである",
  101837: "買い渋り",
  101838: "キャッシュタイム",
  101839: "現金通貨",
  101840: "引き出し数量",
  101841: "ユーザコミッション",
  101842: "引き出し可能金額",
  101843: "撤回する",
  101844: "コミュニティ",
  101845: "電子メール (この電子メールはエージェント情報を受け取るために使用されます。確認情報が見つからない場合は、スパム メールを確認してください)",
  101846: "検証コード",
  101847: "申請は審査中ですので、しばらくお待ちください。 審査通過後、メールにてご連絡させていただきます。",
  101848: "申し訳ありませんが、エージェントの申請は承認されませんでした",
  101849: "再申請",
  101850: "データの概要",
  101851: "代理店契約リベート率",
  101852: "エージェントのスポット リベート率",
  101853: "代理人としての資格を剥奪されました。ご不明な点がございましたら、管理者にお問い合わせください。",
  101854: "ずっと",
  101855: "昨日",
  101856: "今月",
  101857: "先月",
  101858: "トレーダーの数",
  101859: "総預金額",
  101860: "招待コードを選択してください",
  101861: "総収入",
  101862: "契約手数料",
  101863: "スポットコミッション",
  101864: "現金引き出し待ち",
  101865: "引き出し済み",
  101866: "ロック解除待ち",
  101867: "*手数料収入は使用する前にスポット口座に引き出す必要があります",
  101868: "出金確認",
  101869: "すべてのトークンを私のスポット口座に出金してもよろしいですか?",
  101870: "現在のトークンが出金額を満たしていません。ボーナスを受け取るために、より多くのユーザーを取引に招待できます。",
  101871: "ロック解除済み",
  101872: "逆向き",
  101873: "エージェント資格が取り消されました",
  101874: "すでにエージェントです",
  101875: "チャネルデータの概要",
  101876: "ユーザデータ",
  101877: "クラウドウォレット契約口座へ",
  101878: "クラウドウォレットスポットアカウントに移動",
  101879: "スポット取引詳細",
  101880: "契約取引詳細",
  101881: "契約決済センター",
  101882: "スポット決済センター",
  101883: "パフォーマンスレポート",
  101884: "言語を選択してください",
  101885: "答えを入力してください",
  101886: "チャンネル名を選択してください",
  101887: "コミッション引き出し",
  101888: "チャンネル名を入力してください",
  101889: "プロモーション方法を選択してください",
  101890: "備考欄にご記入ください",
  101891: "現金化可能な資産",
  101892: "出金の確認",
  101893: "ユーザー契約のキャッシュバック率を設定する",
  101894: "ユーザーのキャッシュバック率を設定する",
  101895: "契約履行報告書",
  101896: "スポットパフォーマンスレポート",
  101897: "換算（USDT）",
  101898: "クラウドウォレットに出金する",
  101899: "すべてのスポット手数料をクラウド ウォレットに引き出しますか?",
  101900: "ファンドを見る",
  101901: "すべての通貨",
  101902: "現金未引き出し",
  101903: "合計手数料",
  101904: "国または地域を選択してください",
  101905: "認証コードを入力してください",
  101906: "代理店システム",
  101907: "ありがとう",
  101908: "申請書は送信されました。 通常、2 ～ 3 営業日以内にお客様の情報を審査し、審査に合格した後にリベートが有効になります。",
  //代理商拉新
  92000000: "イベントカウントダウン",
  92000001: "参加方法",
  92000002: "報酬を得るチャンスを得るには、タスクを完了するアカウントが現在のページの登録/ログインアカウントと一致していることを確認する必要があります。",
  92000003: "タスク確認待ち",
  92000004: '<span style="color:#000922;font-weight:500;">{brokerName}</span> の招待によりSuperExアカウントを登録して、限定の新規ボーナスをアンロックしましょう！',
  92000005: "{time} から開始",
  92000006: "{time} までに完了",
  92000007: "タスクの完了確認には最大7営業日かかる場合がありますので、ご了承ください。",
  92000008: "イベント終了後、約7日以内",
  92000009: "検証タスクが正しい場合、報酬はイベント終了後7営業日以内にアカウントに配布されます。",
  92000010: '<span style="color:#000922;font-weight:400;">{brokerName}</span> の招待リンクを使用して登録',
  92000011: "利用規約",
  92000012: "アクティビティ進行中",
  92000013: "このイベントに参加できません",
  92000014: "イベントは終了しました",
  92000015: "賞を受賞する",
  92000016: "今すぐログイン",
  92000017: "ニックネームを設定してください",

  92000018: "メモ",
  92000019: "この項目は入力が必須です",
  92000020: "保存",
  92000021: 'ポスターを共有',
  92000022:'最大',
  92000023:'チャネルを編集',
  92000024:'所属チャンネルを作成',
  92000025:'このチャンネルには招待コードがありません',
  92000026:'',
  92000027:'',
  92000028:'',
  92000029:'',
  92000030:'',
};
export default ja;



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/ja.js